import { ASSETS } from "@/data";

export default function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section
      data-testid="page-hero"
      className="relative pt-36 lg:pt-44 pb-16 lg:pb-20"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(20,17,13,0.9), rgba(20,17,13,0.96)), url(${image || ASSETS.toolRack})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {eyebrow && (
          <p className="font-cond tracking-[0.3em] text-gold text-sm mb-4 fade-up">{eyebrow.toUpperCase()}</p>
        )}
        <h1 className="font-display heading-distress text-5xl sm:text-6xl lg:text-7xl leading-[0.95] fade-up" style={{ animationDelay: "0.1s" }}>
          {title}
        </h1>
        <div className="w-20 h-1 mt-6 mb-5" style={{ backgroundColor: "var(--l3-gold)" }} />
        {subtitle && (
          <p className="text-white/70 text-lg max-w-2xl leading-relaxed fade-up" style={{ animationDelay: "0.2s" }}>
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
